// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__In8Yq","tabsBox":"styles_tabsBox__3r4cQ","createButton":"styles_createButton__3nK-J"};